export type CounterOperationType =
    "None"
    | "Increment"
    | "Delete"
    | "Get"
    | "Put"
    | "GetAll";
